import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { HELP_DASHBOARD } from "@/constants/HelpUrls";
import FabBar from "@/design/components/FabBar";
import Page from "@/design/layouts/Page";
import { setSystemSettingsPage } from "@/store/reducers/app";
import { createNewDashboard } from "@/store/reducers/dashboard";
import { setHelpUrl } from "@/store/reducers/ui";
import Valkyrie, { viGear } from "@sippy-platform/valkyrie";

import { Button, Grid } from "@mui/material";

import QueueActivity from "./QueueActivity";
import Setup from "./setup/Setup";
import UserActivity from "./UserActivity";

export default function Dashboard() {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const pbx = useSelector((state) => state.domain.pbx);
  const dashboardSettings = useSelector((state) => state.dashboard.find((_pbx) => _pbx.context === pbx.context));

  const canViewQueues = auth.accessLevel <= 3;

  // Setup a new dashboard in the store if we cannot find any
  useEffect(() => {
    if (dashboardSettings === undefined) {
      dispatch(createNewDashboard({ pbx: pbx.context }));
    }
  }, [dashboardSettings, dispatch, pbx.context]);

  useEffect(() => {
    dispatch(setHelpUrl(HELP_DASHBOARD));
  }, [dispatch]);

  return (
    <Page fabBar maxWidth="xxl">
      <title>{`Dashboard \u00b7 ${pbx.name} \u00b7 ${import.meta.env.SIPPY_APP_TITLE}`}</title>
      {dashboardSettings && (
        <Grid
          container
          sx={{
            gap: 1,
            mt: dashboardSettings.settings.showSetup ? 2 : 0,
          }}
        >
          {dashboardSettings.settings.showSetup && <Setup />}
          <Grid
            sx={{
              gap: 2,
              display: "grid",
              alignItems: "flex-start",
              gridTemplateColumns: {
                xs: "auto",
                md: canViewQueues && dashboardSettings.settings.showQueues ? "auto 360px" : "auto",
              },
            }}
            size={12}
          >
            <UserActivity />
            {canViewQueues && dashboardSettings.settings.showQueues && <QueueActivity />}
          </Grid>
        </Grid>
      )}
      <FabBar>
        <Button
          variant="contained"
          onClick={() => dispatch(setSystemSettingsPage("dashboard"))}
          sx={{ px: 1.25, fontSize: "1rem" }}
          id="dashboardSettings"
        >
          <Valkyrie icon={viGear} />
        </Button>
      </FabBar>
    </Page>
  );
}
